module.exports = () => {
  return {
    brand_image_file: {
      label: '品牌形象',
      type: 'form-upload',
      props: {
        tip: '尺寸要求为200px*200px，格式为jpg/jpeg/png，文件大小小于300k',
        restriction: {
          width: 200,
          height: 200,
          max_size: 300 * 1024,
        },
        isFile: true,
      },
      value: {
        url: '',
        file: null,
      },
      rules: { required: true, trigger: ['change'], message: '请上传品牌形象' },
    },
    name: {
      label: '品牌名称',
      type: 'input',
      value: '',
      rules: { required: true, trigger: ['change'], message: '请输入品牌名称' },
    },
    desc: {
      label: '品牌简介',
      type: 'input',
      value: '',
      rules: { required: true, trigger: ['change'], message: '请输入品牌简介' },
    },
    brand_type: {
      label: '品牌形象类型',
      type: 'radio-group',
      isButton: true,
      options: [
        { label: '品牌空间MID', value: 'mid' },
        { label: '品牌空间链接', value: 'space_url' },
      ],
      value: 'mid',
    },
    mid: {
      label: ' ',
      type: 'input',
      value: '',
      hidden: false,
      rules: { required: true, trigger: ['change'], message: '请输入品牌空间MID' },
    },
    space_url: {
      label: ' ',
      type: 'input',
      value: '',
      hidden: true,
      rules: { required: true, trigger: ['change'], message: '请输入品牌空间链接' },
    },
  };
};
